// extracted by mini-css-extract-plugin
export default {"numberInput":"AuthPage_numberInput__RugUG"};